// TODO: перевірити як працює для різних часових поясів
export const parseUTCDate = (dateUTC: Date) => {
  const userTimezoneOffset = dateUTC.getTimezoneOffset() * 60000
  return new Date(dateUTC.getTime() + userTimezoneOffset)
}
